// manually edited

export interface ObjectConfig {
  item: string;
  numFrames: number;
  numSounds: number;
}

export const objectConfig: { [key: string]: ObjectConfig } = {
  object_jelen: {
    item: 'jelen_n',
    numFrames: 2,
    numSounds: 1,
  },
  object_medved: {
    item: 'medved_n',
    numFrames: 2,
    numSounds: 1,
  },
  object_bobr: {
    item: 'bobr_n',
    numFrames: 2,
    numSounds: 1,
  },
  object_veverka: {
    item: 'veverka_n',
    numFrames: 2,
    numSounds: 1,
  },
  object_vlk: {
    item: 'vlk_n',
    numFrames: 2,
    numSounds: 2,
  },
  object_had: {
    item: 'had_n',
    numFrames: 2,
    numSounds: 1,
  },
  object_zaba: {
    item: 'zaba_n',
    numFrames: 2,
    numSounds: 2,
  },
  object_divocak: {
    item: 'divocak_n',
    numFrames: 2,
    numSounds: 2,
  },
  object_vyr: {
    item: 'vyr_n',
    numFrames: 2,
    numSounds: 2,
  },
};
